import { OrderedList, List } from 'grommet-icons'
import { Box, Button } from 'grommet'
import React from 'react'

const TextAreaToolbarListComponent = props => {
  const onClickOrderedList = () => {
    const { onChange } = props
    onChange('ordered')
  }
  const onClickUnOrderedList = () => {
    const { onChange } = props
    onChange('unordered')
  }
  const currentState = props.currentState

  return (
    <Box direction="row" pad={{ left: 'small' }} gap="small">
      <Box
        border={
          currentState.listType === 'ordered' ? { color: 'darkTint' } : false
        }
        round={'small'}>
        <Button
          icon={<OrderedList color="primary" />}
          onClick={onClickOrderedList}
        />
      </Box>
      <Box
        border={
          currentState.listType === 'unordered' ? { color: 'darkTint' } : false
        }
        round={'small'}>
        <Button
          icon={<List color="primary" />}
          onClick={onClickUnOrderedList}
        />
      </Box>
    </Box>
  )
}

export default TextAreaToolbarListComponent
